export const COULD_NOT_CONNECT = 'COULD NOT CONNECT';
export const MAKE_SURE_YOU_ARE_CONNECTED_TO_WIFI = 'Make sure you are connected to Wi-Fi.';
